var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"csn-dark-mode-toggle"},[_c('div',{staticClass:"cs-textstyle-detail-heading csn-dark-mode-toggle__title"},[_vm._v(" THEME ")]),_c('cs-button-group',{attrs:{"values":_vm.selectedTheme,"size":"small","fade":"","buttons":_vm.themeButtons},on:{"input":_vm.selectTheme}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }